import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {logoutFromTnAccount} from "../components/header/header-actions";

export class LogoutFromTnAccountContainer extends Component {

    handleLogout() {
        this.props.logoutFromTnAccount();
    }

    render() {
        return (
            <span onClick={this.handleLogout.bind(this)}>
                { this.props.children }
             </span>
        );
    }

}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        logoutFromTnAccount
    }, dispatch
);

export default connect(
    null,
    mapDispatchToProps,
)(LogoutFromTnAccountContainer);
